import { Box } from '@material-ui/core'

import { SelectedLayer } from './SelectedLayer'
import { Draggable } from 'react-beautiful-dnd'

import { LAYER_KIND } from '../../utils/configQueries'

import { useStyles } from './styles'

export const SelectedLayers = ({ layers }) => {
  const classes = useStyles()
  const layersData = layers
    .filter(({ metadata }) => metadata)
    .filter(({ kind }) => kind === LAYER_KIND.EXTERNAL)
    .map(
      ({
        id,
        isVisible,
        metadata: {
          indicator_name: name,
          unit: description,
          layer: nameLegendGraphi
        },
        dimensions,
        membersValues,
        opacity
      }) => ({
        id,
        isVisible,
        name,
        nameLegendGraphi,
        description,
        params: dimensions
          .map(({ name: dimensionName, members }, idx) => ({
            dimensionName,
            value: members.find(
              ({ id: memberId }) =>
                memberId ===
                (idx < membersValues.length ? membersValues[idx] : null)
            )?.name
          }))
          .filter(({ value }) => !!value),
        opacity
      })
    )

  return (
    <Box className={classes.containerAccordion}>
      {layersData?.map(
        (
          {
            id,
            isVisible,
            name,
            params,
            description,
            opacity,
            nameLegendGraphi
          },
          index
        ) => (
          <Box key={id}>
            <Draggable draggableId={id} index={index}>
              {(draggableProvided) => (
                <Box
                  {...draggableProvided.draggableProps}
                  ref={draggableProvided.innerRef}
                  className="layer-item"
                >
                  <SelectedLayer
                    id={id}
                    nameLegendGraphi={nameLegendGraphi}
                    isVisible={isVisible}
                    name={name}
                    params={params}
                    description={description}
                    opacity={opacity}
                    dragProvided={draggableProvided}
                  />
                </Box>
              )}
            </Draggable>
          </Box>
        )
      )}
    </Box>
  )
}
